module.exports = __webpack_public_path__ + "img/plan-01.e67cf611.png";